export default class Entity extends PIXI.Container {

    get activated() {
        return this._activated;
    }

    constructor(anchor, texture) {
        super();

        this.type = null;

        this._view = new PIXI.Sprite(texture);
        this._view.anchor = anchor;
        this.addChild(this._view);

        this.headCollision = false;

    }

    update(dt) {

    }

    activate() {
        // do nothing
    }

    deactivate() {
        // do nothing
    }

}